import React from "react";
import { Link } from "react-router-dom";
import "./Donationheader.css";

export default function Donationheader() {
  const base = process.env.PUBLIC_URL;

  return (
    <section
      className="donation-hero"
      role="banner"
      aria-label="Donation hero banner"
    >
      {/* Background image (full width) */}
      <img
        className="donation-hero__bg"
        src={`${base}/(232).webp`}
        alt="Team helping with donation services"
        loading="eager"
      />

      {/* Contrast overlay */}
      <div className="donation-hero__overlay" aria-hidden="true" />

      {/* Centered content */}
      <div className="donation-hero__content">
        <nav className="donation-hero__breadcrumb" aria-label="Breadcrumb">
          <Link to="/" className="donation-hero__breadcrumb-link">Home</Link>
          <span className="donation-hero__breadcrumb-sep" aria-hidden="true">›</span>
          <span className="donation-hero__breadcrumb-current">Donations</span>
        </nav>

        <h1 className="donation-hero__title">Donation Services</h1>
        <p className="donation-hero__subtitle">
          Supporting communities with responsible donation pickup and delivery.
        </p>
      </div>

      {/* Premium depth touches */}
      <div className="donation-hero__vignette" aria-hidden="true" />
      <div className="donation-hero__grain" aria-hidden="true" />
    </section>
  );
}
